import { FactorsAffectingCareConstants } from './factorsAffectingCare.constants'
import { IFactorsAffectingCareAction, IFactorsAffectingCareState } from './factorsAffectingCare.types'

export const initialFactorsAffectingCareState: IFactorsAffectingCareState = {
  dispatchFactors: [],
  dispatchFactorsPNNV: null,
  responseFactors: [],
  responseFactorsPNNV: null,
  sceneFactors: [],
  sceneFactorsPNNV: null,
  transportFactors: [],
  transportFactorsPNNV: null,
  turnAroundFactors: [],
  turnAroundFactorsPNNV: null,
  factors: [],
  showFactors: false,
  showDispatchFactors: false,
  showTurnAroundFactors: false,
  showResponseSceneTransportFactors: false,
}

export function factorsAffectingCareReducer(
  state: IFactorsAffectingCareState = initialFactorsAffectingCareState,
  action: IFactorsAffectingCareAction
): IFactorsAffectingCareState {
  switch (action.type) {
    case FactorsAffectingCareConstants.SET_DISPATCH_FACTORS:
      return { ...state, dispatchFactors: action.dispatchFactors }
    case FactorsAffectingCareConstants.SET_DISPATCH_FACTORS_PNNV:
      return { ...state, dispatchFactorsPNNV: action.dispatchFactorsPNNV }
    case FactorsAffectingCareConstants.SET_RESPONSE_FACTORS:
      return { ...state, responseFactors: action.responseFactors }
    case FactorsAffectingCareConstants.SET_RESPONSE_FACTORS_PNNV:
      return { ...state, responseFactorsPNNV: action.responseFactorsPNNV }
    case FactorsAffectingCareConstants.SET_SCENE_FACTORS:
      return { ...state, sceneFactors: action.sceneFactors }
    case FactorsAffectingCareConstants.SET_SCENE_FACTORS_PNNV:
      return { ...state, sceneFactorsPNNV: action.sceneFactorsPNNV }
    case FactorsAffectingCareConstants.SET_TRANSPORT_FACTORS:
      return { ...state, transportFactors: action.transportFactors }
    case FactorsAffectingCareConstants.SET_TRANSPORT_FACTORS_PNNV:
      return { ...state, transportFactorsPNNV: action.transportFactorsPNNV }
    case FactorsAffectingCareConstants.SET_TURN_AROUND_FACTORS:
      return { ...state, turnAroundFactors: action.turnAroundFactors }
    case FactorsAffectingCareConstants.SET_TURN_AROUND_FACTORS_PNNV:
      return { ...state, turnAroundFactorsPNNV: action.turnAroundFactorsPNNV }
    case FactorsAffectingCareConstants.SET_FACTORS:
      return { ...state, factors: action.factors }
    case FactorsAffectingCareConstants.SET_SHOW_FACTORS:
      return { ...state, showFactors: action.showFactors }
    case FactorsAffectingCareConstants.SET_SHOW_DISPATCH_FACTORS:
      return { ...state, showDispatchFactors: action.showDispatchFactors }
    case FactorsAffectingCareConstants.SET_SHOW_TURN_AROUND_FACTORS:
      return { ...state, showTurnAroundFactors: action.showTurnAroundFactors }
    case FactorsAffectingCareConstants.SET_SHOW_RESPONSE_SCENE_TRANSPORT_FACTORS:
      return { ...state, showResponseSceneTransportFactors: action.showResponseSceneTransportFactors }
    case FactorsAffectingCareConstants.SET_FACTORS_AFFECTING_CARE_STATE:
      return { ...action.factorsAffectingCare }
    case FactorsAffectingCareConstants.RESET_FACTORS_AFFECTING_CARE_STATE:
      return { ...initialFactorsAffectingCareState }
    default:
      return state
  }
}
